var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.description)?_c('div',{staticClass:"paragraph-s paragraph-dark-gray"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),(_vm.location)?_c('location-with-icon',{attrs:{"location":_vm.location}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }